export default "__VITE_ASSET__a90ddc0a__"